const store = {
  isDragging: false,
}

export default store
